module.exports = __webpack_public_path__ + "static/media/Photo3.365c62d3.jpg";